import { Container, Grid } from '@dtpk-cc/components';
import { Outlet } from 'react-router-dom';

export const MainLayout = () => {
    const containerVariants = [
        Container.Variant.padded,
        Container.Variant.centered,
        Container.Variant.fixedSmall,
        Container.Variant.unsetInnerAlignment,
    ];

    const rowStyle = {
        justifyContent: 'center',
    };

    return (
        <Container variants={containerVariants}>
            <Grid>
                <Grid.Row gutter style={rowStyle}>
                    <Grid.Col s={6} m={11} l={9} xl={18}>
                        <Outlet />
                    </Grid.Col>
                </Grid.Row>
            </Grid>
        </Container>
    );
};
